import PropTypes from 'prop-types';
import React from 'react';

const SearchIcon = ({ width = 13, height = 13, ...props }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 13"
    {...props}
  >
    <path d="M8.54513976,2.80998877 C6.96109933,1.22594834 4.3940292,1.22594834 2.80998877,2.80998877 C1.22594834,4.3940292 1.22594834,6.96109933 2.80998877,8.54513976 C4.3940292,10.1291802 6.96109933,10.1291802 8.54513976,8.54513976 C10.1291802,6.96109933 10.1291802,4.3940292 8.54513976,2.80998877 M12.7627589,12.7627589 C12.4456264,13.0790804 11.9322124,13.0790804 11.6150799,12.7627589 L9.06098702,10.207855 C6.83700399,11.8705703 3.68352259,11.7132206 1.66312079,9.69200774 C-0.554373596,7.47532443 -0.554373596,3.88061517 1.66312079,1.66312079 C3.87980409,-0.554373596 7.47532443,-0.554373596 9.69200774,1.66312079 C11.7132206,3.68352259 11.8705703,6.83700399 10.207855,9.06098702 L12.7627589,11.6158909 C13.0790804,11.9322124 13.0790804,12.4456264 12.7627589,12.7627589" />
  </svg>
);

SearchIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default SearchIcon;
